export default function arrayContains(array, element){
  return array.indexOf(element) > -1;
};